import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 75px;
    @media (min-width: 720px) {
        margin-top: 40px;
        margin-left: 200px
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-left: 25px
    }
`;

export const Title = styled.h1`
    color: #333;
    width: 100%;
    leading-trim: both;
    text-edge: cap;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
`;

export const TitleContainer = styled.div`
    display: flex;
    width: 100%;
    padding-block: 20px;
    justify-content: center;
    align-self: flex-start;
    @media (min-width: 720px) {
        width: 90%;
    }
`;

export const ContainerRow = styled.form`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 20px;
    @media (min-width: 1100px) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
    }
`;

export const ContainerColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    padding: 20px;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    @media (min-width: 1100px) {
        width: 40%;
    }
`;

export const ImageIcon = styled.img`
    width: 24px;
    height: 24px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 25px;
    padding-bottom: 150px;
    @media (min-width: 1100px) {
        padding: 20px;
        width: 30%;
        margin-right: 10%;
        justify-content: space-between;
        align-self: flex-end;
    }
`;

export const ContainerHead = styled.div`
    display: flex; 
    width: 100%;
    justify-content: center;
    @media (min-width: 1100px) {
        width: 90%;
        justify-content: flex-end;
    }
`

export const ContainerCheckbox = styled.form`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 20px;
`;

export const ContainerButtons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 25px;
    width: 100%;
    padding-bottom: 150px;
`